import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class SLAType extends AdornisEntity {
  static override _class = 'SLAType';

  static override resolveID(entity: any): string {
    return entity.priority + '-' + entity.type;
  }

  @Field(() => String)
  priority: Maybe<string>;

  @Field(() => String)
  type: Maybe<string>;
}
